'use client';
import { useEffect } from 'react';
import { getCookie, setCookie } from '@/lib/utils';
import { usePathname, useSearchParams } from 'next/navigation';

const hasUTM = (str) => /(\?|&)utm/i.test(str);

export function UrlCapture() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const url = new URL(window.location.href);
    const callbackUrl = url.searchParams.get('callbackUrl');
    const currentUrl =
      callbackUrl && !hasUTM(window.location.href)
        ? callbackUrl
        : window.location.href;
    const landingUrl = getCookie('landing_url');
    if (!landingUrl || hasUTM(currentUrl)) {
      setCookie('landing_url', currentUrl);
    }
    const currReferr = getCookie('http_referrer');
    let referrerUrl;
    try {
      referrerUrl = new URL(document.referrer);
    } catch(err) {
      /* ignore */
    }
    if(!currReferr && referrerUrl && referrerUrl.host !== url.host) {
      setCookie('http_referrer', document.referrer);
    }
  }, [pathname, searchParams]);

  return null;
}
